// extracted by mini-css-extract-plugin
export default {"header":"Header_styles_header__bHG1q","logo":"Header_styles_logo__5VfNW"};